import { useCallback, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider.js';
import { listAreas, validateArea } from '../api/quality.js';
import { ApiError } from '../api/client.js';

export function AreaValidationPage(): ReactNode {
  const { id = '' } = useParams<{ id: string }>();
  const { token } = useAuth();
  const [rows, setRows] = useState<readonly unknown[]>([]);
  const [form, setForm] = useState({ executionAreaId: '', approvedAreaSqm: '', executedAreaSqm: '' });
  const [error, setError] = useState<string | null>(null);
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { setRows(await listAreas(id, token)); } catch (err) { setError(err instanceof ApiError ? err.message : 'Load failed'); }
  }, [id, token]);
  useEffect(() => { void load(); }, [load]);

  async function submit(): Promise<void> {
    setError(null); setMsg(null); setBusy(true);
    try {
      await validateArea(id, {
        executionAreaId: form.executionAreaId,
        approvedAreaSqm: Number(form.approvedAreaSqm),
        executedAreaSqm: Number(form.executedAreaSqm),
      }, token);
      setMsg('Saved'); await load();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Save failed');
    } finally { setBusy(false); }
  }

  return (
    <main aria-label="area-validation">
      <h1>Area validation — {id}</h1>
      {error ? <div role="alert">{error}</div> : null}
      {msg ? <div role="status">{msg}</div> : null}
      <div aria-label="area-count">{rows.length} record(s)</div>
      <form aria-label="area-form" onSubmit={(e) => { e.preventDefault(); void submit(); }}>
        <label>Execution Area ID<input aria-label="execAreaId" value={form.executionAreaId} onChange={(e) => setForm({ ...form, executionAreaId: e.target.value })} required /></label>
        <label>Approved (sqm)<input aria-label="approvedAreaSqm" value={form.approvedAreaSqm} onChange={(e) => setForm({ ...form, approvedAreaSqm: e.target.value })} required /></label>
        <label>Executed (sqm)<input aria-label="executedAreaSqm" value={form.executedAreaSqm} onChange={(e) => setForm({ ...form, executedAreaSqm: e.target.value })} required /></label>
        <button type="submit" disabled={busy}>Validate</button>
      </form>
    </main>
  );
}
